class CustomerInfosDto {
    Name: string;
    CustomerFragment: string;

    constructor(name: string, customerFragment: string) {
        this.Name = name;
        this.CustomerFragment = customerFragment;
    }
}

export default CustomerInfosDto;
